import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  ProgressBar,
  ListGroup,
  Dropdown,
  Table,
  Alert,
} from "react-bootstrap";
import {
  FaChartBar,
  FaUsers,
  FaTicketAlt,
  FaGavel,
  FaUserPlus,
  FaFolderPlus,
  FaFileAlt,
  FaWarehouse,
  FaBriefcase,
  FaChevronRight,
  FaExclamationCircle,
  FaCheckCircle,
  FaClock,
  FaEye,
  FaEdit,
  FaTrash,
  FaArrowUp,
  FaArrowDown,
  FaFilter,
  FaSearch,
  FaBell,
  FaCog,
  FaCalendar,
  FaChartLine,
  FaDollarSign,
  FaBoxOpen,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { logout } from "../redux/authSlice/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../apiServices/EmpApiServices";
import { setEmpData } from "../redux/empSlice/empSlice";
import { useNavigate } from "react-router-dom";
import {
  fetchAcutionVehicles,
  fetchAuctionVehicles,
} from "../apiServices/AuctionApiServices";
import { setAuctionData } from "../redux/auctionSlice/auctionSlice";
import moment from "moment";
import { fetchTickets } from "../apiServices/SupportTicketApiServices";
import { setTicketData } from "../redux/supportTicketSlice/supportTicketSlice";
import { setYardData } from "../redux/yardSlice/yardSlice";
import { MdPermMedia } from "react-icons/md";
import axios from "axios";
import { Baseurl } from "../baseurl";
const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginData } = useSelector((store) => store.auth);
  const { empList } = useSelector((state) => state.emp);
  const { auctionList } = useSelector((state) => state.auction);
  const { yardList } = useSelector((state) => state.yard);
  const { ticketList, closedPercentage } = useSelector((state) => state.ticket);

  useEffect(() => {
    loadData();
  }, []);
  const loadData = async () => {
    const getEmpData = await fetchEmployees();
    if (getEmpData.success) {
      dispatch(setEmpData(getEmpData.data));
    }
    const getAuctionData = await fetchAuctionVehicles();
    if (getAuctionData.success) {
      dispatch(setAuctionData(getAuctionData.data));
    }
    const getSupportTicketData = await fetchTickets();
    if (getSupportTicketData.success) {
      dispatch(setTicketData(getSupportTicketData.data));
    }
    const getYardData = await fetchYards();
    if (getYardData.success) {
      dispatch(setYardData(getYardData.yards));
    }
  };
  const fetchEmployees = async () => {
    const agencyId =
      loginData.role === "Agency" ? loginData._id : loginData.organisation?.id;

    if (!agencyId) return;
    // Replace with your actual API endpoint
    const response = await axios.get(
      `${Baseurl}/api/fieldOfficer/all/${agencyId}`,
    );
    return response.data;
  };
  const fetchYards = async () => {
  try {
    if (!loginData?.role) return;

    const agencyId =
      loginData.role === "Agency"
        ? loginData._id
        : loginData.organisation?.id;

    if (!agencyId) {
      console.warn("Agency ID not found", loginData);
      return;
    }

    const response = await axios.get(
      `${Baseurl}/api/yards/getAllYardForAdmin/${agencyId}`
    );

    if (response.data?.success) {
      return response.data;
    }
  } catch (error) {
    if (error.response?.status === 404) {
      console.error("Yards API not found (404)");
    } else {
      console.error("Failed to fetch yards", error);
    }
  }
};

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
      },
    },
  };

  const cardVariants = {
    hover: {
      y: -5,
      transition: {
        duration: 0.3,
      },
    },
  };
  const handleLogOut = async () => {
    await dispatch(logout());
  };

  const StatCard = ({ title, value, icon: Icon, color, change, children }) => (
    <motion.div
      variants={itemVariants}
      whileHover="hover"
      // variants={cardVariants}
    >
      <Card className="h-100 shadow-sm border-0">
        <Card.Body>
          <Row className="align-items-center">
            <Col xs={8}>
              <div className="d-flex align-items-center mb-2">
                <div
                  className={`p-2 rounded-circle me-3 bg-${color} bg-opacity-10`}
                >
                  <Icon className={`text-${color}`} size={24} />
                </div>
                {change && (
                  <Badge
                    bg={change > 0 ? "success" : "danger"}
                    className="ms-2"
                  >
                    {change > 0 ? <FaArrowUp /> : <FaArrowDown />}{" "}
                    {Math.abs(change)}%
                  </Badge>
                )}
              </div>
              <h3 className="fw-bold mb-1">{value}</h3>
              <p className="text-muted mb-0">{title}</p>
              {children && <div className="mt-3">{children}</div>}
            </Col>
            <Col xs={4} className="text-end">
              <div className="position-relative" style={{ height: "80px" }}>
                <div
                  className={`position-absolute w-100 h-100 rounded bg-${color} bg-opacity-10`}
                ></div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </motion.div>
  );

  const ActionButton = ({ text, icon: Icon, variant, onClick }) => (
    <motion.div whileTap={{ scale: 0.95 }}>
      <Button
        variant={variant}
        onClick={onClick}
        className="d-flex align-items-center justify-content-center w-100 py-3"
      >
        <Icon className="me-2" />
        <span>{text}</span>
      </Button>
    </motion.div>
  );

  const SectionHeader = ({ title, icon: Icon, count, onViewAll }) => (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div className="d-flex align-items-center">
        <div className="p-2 bg-primary bg-opacity-10 rounded-circle me-3">
          <Icon className="text-primary" />
        </div>
        <div>
          <h4 className="fw-bold mb-0">{title}</h4>
          {count && (
            <Badge bg="primary" className="ms-2">
              {count}
            </Badge>
          )}
        </div>
      </div>
      <Button
        variant="link"
        onClick={onViewAll}
        className="text-decoration-none"
      >
        View All <FaChevronRight className="ms-1" />
      </Button>
    </div>
  );

  return (
    <Container fluid className="py-4 bg-light min-vh-100">
      {/* Header */}
      <motion.div
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="mb-4"
      >
        <Row className="align-items-center mb-4">
          <Col>
            <h1 className="fw-bold text-dark mb-1">
              Agency Management Dashboard
            </h1>
            <p className="text-muted mb-0">
              Welcome back! Here's what's happening today.
            </p>
          </Col>
          <Col xs="auto">
            <div
              className="user-info d-flex justify-content-center align-items-center bg-primary text-white"
              onClick={() => handleLogOut()}
            >
              <div className="text-center">
                <span>Log Out</span>
              </div>
            </div>
          </Col>
        </Row>
      </motion.div>

      {/* Stats Grid */}
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <Row className="g-3 mb-4">
          <Col md={3}>
            <StatCard
              title="Employee List"
              value={empList?.length}
              icon={FaUsers}
              color="success"
              // change={8}
            >
              <div className="d-flex justify-content-between mt-2">
                <small className="text-muted">
                  <FaCheckCircle className="text-success me-1" />
                  Active:{" "}
                  {empList.reduce(
                    (acc, emp) => acc + (emp.isActive ? 1 : 0),
                    0,
                  )}
                </small>
                <small className="text-muted">
                  <FaClock className="text-warning me-1" />
                  Not Active :{" "}
                  {empList.reduce(
                    (acc, emp) => acc + (!emp.isActive ? 1 : 0),
                    0,
                  )}
                </small>
              </div>
            </StatCard>
          </Col>

          <Col md={3}>
            <StatCard
              title="Yard Locations"
              value={yardList.length}
              icon={FaWarehouse}
              color="info"
              change={3}
            >
              <div className="d-flex justify-content-between mt-2">
                <small className="text-muted">
                  Active:{" "}
                  {yardList.filter((indYard) => indYard.isActive).length}
                </small>
                <small className="text-muted">
                  Verified:{" "}
                  {yardList.filter((indYard) => indYard.isVerified).length}
                </small>
              </div>
            </StatCard>
          </Col>
        </Row>
      </motion.div>

      {/* Action Buttons */}
      {loginData.role === "Agency" && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="mb-4"
        >
          <Card className="shadow-sm border-0">
            <Card.Body>
              <h5 className="fw-bold mb-3">Quick Actions</h5>
              <Row className="g-3">
                <Col md={2}>
                  <ActionButton
                    text="Add Employee"
                    icon={FaUserPlus}
                    variant="success"
                    onClick={() => navigate("employees/add")}
                  />
                </Col>
                <Col md={2}>
                  <ActionButton
                    text="Create Yard"
                    icon={FaWarehouse}
                    variant="info"
                    onClick={() => navigate("yards/addYard")}
                  />
                </Col>
                <Col md={2}>
                  <ActionButton
                    text="Create Case"
                    icon={FaBriefcase}
                    variant="primary"
                    onClick={() => navigate("cases/add")}
                  />
                </Col>
                <Col md={2}>
                  <ActionButton
                    text="Upload Image And Video"
                    icon={MdPermMedia}
                    variant="danger"
                    onClick={() => navigate("UploadMedia")}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </motion.div>
      )}
      {/* Main Content */}
      {loginData.role === "Agency" && (
        <Row className="g-4">
          {/* Left Column */}
          <Col lg={8}>
            {/* Auction Management */}
            <motion.div variants={itemVariants}>
              <Card className="shadow-sm border-0 h-100 mt-2">
                <Card.Body>
                  <SectionHeader
                    title="Yard Management"
                    icon={FaWarehouse}
                    count={yardList.length}
                    onViewAll={() => navigate("yards/list")}
                  />

                  <div className="mb-4">
                    <h6 className="fw-bold mb-3">Yard Locations</h6>
                    <ListGroup variant="flush">
                      {yardList.map((yard, index) => (
                        <ListGroup.Item
                          key={index}
                          className="d-flex justify-content-between align-items-center border-0 py-2"
                        >
                          <div className="d-flex align-items-center">
                            <FaWarehouse
                              className={`me-3 ${yard.yardStatus === "operational" ? "text-success" : "text-warning"}`}
                            />
                            <div>
                              <h6 className="fw-bold mb-0">{yard?.yardName}</h6>
                              <small className="text-muted">
                                {yard?.occupancy} lots available
                              </small>
                            </div>
                          </div>
                          <Badge
                            bg={
                              yard.yardStatus === "operational"
                                ? "success"
                                : "warning"
                            }
                          >
                            {yard.yardStatus}
                          </Badge>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </div>

                  <Card className="bg-light border-0">
                    <Card.Body>
                      <Row>
                        <Col>
                          <div className="text-center">
                            <h4 className="fw-bold text-success">
                              {yardList.reduce(
                                (acc, yard) => acc + yard?.occupancy,
                                0,
                              )}
                            </h4>
                            <small className="text-muted">Total Capacity</small>
                          </div>
                        </Col>
                        <Col>
                          <div className="text-center">
                            <h4 className="fw-bold text-primary">
                              {yardList.reduce(
                                (acc, yard) => acc + yard?.parkedVehicles,
                                0,
                              )}
                            </h4>
                            <small className="text-muted">Parked Vehicle</small>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>

          {/* Right Column */}
          <Col lg={4}>
            {/* Employee Directory */}
            <motion.div variants={itemVariants}>
              <Card className="shadow-sm border-0">
                <Card.Body>
                  <SectionHeader
                    title="Employee Directory"
                    icon={FaUsers}
                    count={empList.slice(0, 4).length}
                    onViewAll={() => navigate("employees/list")}
                  />

                  <div className="mb-4">
                    <h6 className="fw-bold mb-3">Emp List</h6>
                    {empList.slice(0, 4).map((employee, index) => (
                      <div
                        key={employee._id}
                        className="d-flex align-items-center mb-3"
                      >
                        <div
                          className={`text-white rounded-circle d-flex align-items-center justify-content-center me-3 ${
                            index % 2 === 0 ? "bg-primary" : "bg-success"
                          }`}
                          style={{ width: "40px", height: "40px" }}
                        >
                          {employee.name.charAt(0)}
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="fw-bold mb-0">{employee.name}</h6>
                          <small className="text-muted">
                            {employee.phoneNo}
                          </small>
                        </div>
                        <div className="text-end">
                          <small className="fw-bold">{employee.role}</small>
                        </div>
                      </div>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>
      )}
      {/* Footer */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
        className="mt-4 pt-3 border-top"
      >
        <Row className="align-items-center">
          <Col>
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center me-4">
                <div className="w-3 h-3 bg-success rounded-circle me-2"></div>
                <small className="text-muted">All systems operational</small>
              </div>
              <small className="text-muted">
                <FaCalendar className="me-1" />
                Last updated: Today, 10:30 AM
              </small>
            </div>
          </Col>
          <Col xs="auto">
            <div className="d-flex gap-3">
              <small className="text-muted">
                Total Employees: {empList.length}
              </small>
              <small className="text-muted">
                Active Yards: {yardList.length}
              </small>
            </div>
          </Col>
        </Row>
      </motion.div>
    </Container>
  );
};

export default Dashboard;
